import { render } from "./LoginNav.vue?vue&type=template&id=9061ff36&scoped=true&ts=true"
import script from "./LoginNav.vue?vue&type=script&lang=ts"
export * from "./LoginNav.vue?vue&type=script&lang=ts"

import "./LoginNav.vue?vue&type=style&index=0&id=9061ff36&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9061ff36"]])

export default __exports__